import React from "react"
import {useTranslation} from "react-i18next"
import {Formik, Form, FormikProps, FormikValues, Field, FieldProps} from "formik"
import {FormControl, TextField, Typography} from "@material-ui/core"

// HOCs
import withSignIn, {WithSignInProps} from "../../hoc/withSignIn"

// Components
import Button from "../../../../components/Button"

// Models
import {SignInCredentials} from "../../models"

// Utils
import Utils from "../../../../utils/Utils"

// Styles
import useStyles from "./styles"

/**
 * @param props
 */
function SignInForm(props: WithSignInProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");
    const {signIn, signingIn, signInErrorMessage} = props;

    function handleSubmit(values: SignInCredentials) {
        if (signingIn) return

        signIn(values);
    }

    return (
        <div className={styles.container}>
            <Typography component="h1" variant="h5">{t("sign_in.title")}</Typography>
            <Formik onSubmit={handleSubmit} initialValues={{username: "", password: ""}}>
                {(props: FormikProps<FormikValues>) => {
                    const {isValid, handleSubmit} = props;

                    return (
                        <Form onSubmit={handleSubmit} noValidate className={styles.form}>
                            <Field type="emil" name="username" validate={Utils.validateEmail}>
                                {(props: FieldProps) => {
                                    const {field, form: {touched, errors, submitCount}} = props;
                                    const error = errors[field.name];
                                    const submitted = submitCount > 0;
                                    const fieldTouched = touched[field.name] as boolean;
                                    const touchedError = hasError() && fieldTouched;
                                    const submittedError = hasError() && submitted;

                                    function hasError() {
                                        return typeof error !== "undefined"
                                    }

                                    function getHelperText() {
                                        if (submittedError || touchedError) {
                                            return t(error as string)
                                        }
                                    }

                                    return (
                                        <FormControl fullWidth margin="normal" variant="outlined">
                                            <TextField required
                                                       id="email"
                                                       variant="outlined"
                                                       helperText={getHelperText()}
                                                       error={submittedError || touchedError}
                                                       label={t("sign_in.form.label.email")} {...field}/>
                                        </FormControl>
                                    )
                                }}
                            </Field>
                            <Field type="password" name="password" validate={Utils.validatePassword}>
                                {(props: FieldProps) => {
                                    const {field, form: {touched, errors, submitCount}} = props;
                                    const error = errors[field.name];
                                    const submitted = submitCount > 0;
                                    const fieldTouched = touched[field.name] as boolean;
                                    const touchedError = hasError() && fieldTouched;
                                    const submittedError = hasError() && submitted;

                                    function hasError() {
                                        return typeof error !== "undefined"
                                    }

                                    function getHelperText() {
                                        if (submittedError || touchedError) {
                                            return t(error as string)
                                        }
                                    }

                                    return (
                                        <FormControl fullWidth margin="normal" variant="outlined">
                                            <TextField required
                                                       id="password"
                                                       type="password"
                                                       variant="outlined"
                                                       helperText={getHelperText()}
                                                       error={submittedError || touchedError}
                                                       label={t("sign_in.form.label.password")} {...field}/>
                                        </FormControl>
                                    )
                                }}
                            </Field>
                            {signInErrorMessage !== null && (
                                <Typography className={styles.sign_in_error}>{t(signInErrorMessage)}</Typography>
                            )}
                            <Button fullWidth
                                    size="large"
                                    type="submit"
                                    color="primary"
                                    variant="contained"
                                    disabled={!isValid}
                                    loading={signingIn}
                                    label={t("sign_in.submit")}
                                    className={styles.submit_button}/>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    )
}

export default withSignIn(SignInForm)
